export default {
      id: "graph-pn-usage",
      viewBox: "0 0 132 132",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-pn",
      toString: function () {
        return this.url;
      }
    }